exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n*[data-v-11f2f163] {\n  font-family: Moderat;\n  font-style: normal;\n  font-weight: normal;\n  /* #E4E5E7 */\n}\n.deactivate-account-container[data-v-11f2f163] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  margin-top: 12px;\n}\n.deactivate-card[data-v-11f2f163] {\n  background: #ffffff;\n  border-radius: 4px;\n  padding: 24px 12px;\n  width: 49%;\n}\n", ""]);

// exports
